import '../../../node_modules/ui-theme/widgets/profile-menu/js/profile-menu';
(function () {
    UX.dropblockUl.vPort = 'screen-md';
})(UX);
